<template>
  <div class="l-wrapper">
    <h2 class="c-heading">お問い合わせ</h2>
    <p class="c-description">
      お問い合わせいただき、ありがとうございました。
      内容確認後、改めてこちらからご連絡差し上げます。
    </p>

    <a class="c-button" href="/">TOPページへ</a>
  </div>
</template>

<script>
export default {
  name: 'ContactComplete',
  components: {},
  data() {
    return {};
  },
  computed: {},
  created() {},
  methods: {},
};
</script>

<style scoped lang="scss">
@charset "UTF-8";

.c-heading {
  margin: 0 0 40px;
  font-size: 20px;
  font-weight: bold;
  color: #666;
  line-height: 1.5;
  font-family: "メイリオ", "Meiryo", sans-serif;
  text-align: center;
}

.c-description {
  width: 100%;
  max-width: 380px;
  margin: 0 auto;
  font-size: 14px;
  color: #666;
  line-height: 2;
  font-family: "メイリオ", "Meiryo", sans-serif;
}

.c-button {
  display: flex;
  justify-content: center;
  font-family: "メイリオ", "Meiryo", sans-serif;
  width: 100%;
  padding: 17px 0 18px;
  margin: 45px auto 0;
  max-width: 352px;
  border-radius: 40px;
  color: #fff;
  font-size: 18px;
  font-weight: bold;
  background: #e83532;

  &:link,
  &:visited {
    color: #fff;
    text-decoration: none;
  }
}

@media screen and (max-width: 767px) {
  .l-wrapper {
    padding-bottom: 274px;
  }
  .c-heading {
    font-size: 18px;
    margin-bottom: 24px;
  }
  .c-description {
    margin-bottom: 32px;
  }
  .c-button {
    width: 100%;
    margin-top: 65px;
  }
}
</style>
